/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.templates.create.schedules.create.times.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.service.templates',
  'acme.common.service.validate',
  'acme.common.service.userPreferences',
  'acme.common.factory.wizard',
  'acme.view.application.templates.create.schedules.openingHours.controllers',
  'acme.view.application.templates.create.schedules.holidaysExceptions.controllers'
])

.controller('TemplatesCreateSchedulesCreateTimesController', ['$scope', '$state', '$timeout', '$uibModal', 'ApiService', 'HelpersService', 'TemplatesService', 'CalendarService', 'ValidateService', 'WizardFactory', 'UserPreferencesService', function($scope, $state, $timeout, $uibModal, ApiService, HelpersService, TemplatesService, CalendarService, ValidateService, WizardFactory, UserPreferencesService) {

    $scope.templatesCreateSchedulesCreateTimes = {

      model: {},
      calendar:{},
      showModal: {},
      exceptionsCache: {},

      type: 'standard',

      isIndefinite: false,
      showWeekdays: false,
      noExceptions: false,
      hasEndTimeException: false,
      hasStartTimeException: false,
      allowEditExceptions: false,
      startTime: new Date(),
      endTime: new Date(),
      getEth: HelpersService.getEth,
      dateFormats: UserPreferencesService.getDateFormat('extendedDate', 'dateFormat'),
      hourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),
      repeatTypes: TemplatesService.repeatTypes,
      repeatMonthTypes: TemplatesService.repeatMonthTypes,
      getRepeatMonthType: TemplatesService.getRepeatMonthType,
      scheduleHours: [],
      scheduleRepeatMonthType: 'date',
      repeatMonthType: {},
      repeatFrequency: {},
      repeatDays: {
        Su: false,
        M: false,
        Tu: false,
        W: false,
        Th: false,
        F: false,
        Sa: false
      },
      
      scheduleRangeValidators: [],

      init: function() {
        var i, ii;

        if ($state.params && $state.params.scheduleId) {
          this.model = TemplatesService.getScheduleById($state.params.scheduleId).schedule;
        }else{
          this.model = TemplatesService.getNewSchedule().schedule;
        }
        this.initWizard();
        this.getCalendar();
        ValidateService.addFieldTests(this.wizard.getStep('times').validators);

        if (
          ($state.params && $state.params.type && $state.params.type === 'private') ||
          this.model && this.model.type === 'private'
        ) {
          this.type = 'private';
        }

        if (this.model) {
          this.repeatFrequency = TemplatesService.getScheduleRepeatCycle(this.model);
          this.repeatMonthType = this.getScheduleRepeatMonthType();
          this.scheduleHours = TemplatesService.getScheduleHours(this.model);
          this.scheduleRangeHours = TemplatesService.getScheduleRangeHours(this.model);
          // Set warning for ranges
          for (i=0,ii=this.scheduleRangeHours.length;i<ii;i++) {
            this.scheduleRangeHours[i].warning = false;
          }
          if (this.model.effectiveStartTime) {
            this.startTime = CalendarService.parseDate(this.model.effectiveStartTime);
          }
          if (this.model.effectiveEndTime) {
            this.endTime = CalendarService.parseDate(this.model.effectiveEndTime);
          }else{
            this.isIndefinite = true;
          }

          if (!this.model.hasOwnProperty('honorHolidays')) {
            this.model.honorHolidays = false;
          }

          if (!this.model.hasOwnProperty('honorOpenHours')) {
            this.model.honorOpenHours = false;
          }


          this.model.salesChannels = TemplatesService.orderSalesChannels(this.model.salesChannels);

          this.setRepeatDays(this.model.weekdays);
          $timeout(function() {
            $scope.templatesCreateSchedulesCreateTimes.setRepeating();
          }, 0);
          this.updateScheduleRangeValidators();
        }else{
          if ($state.params && $state.params.scheduleId) {
            // No schedule exists but was referenced
            $scope.$emit('TemplatesCreateSchedulesCreateController::Error', { message: 'Schedule does not exist', callback: function() { window.history.go(-1); } });
          }else{
            // Should never occur but in case they arrive at this state manually we will throw a message
            $scope.$emit('TemplatesCreateSchedulesCreateController::Error', { message: 'Schedule could not be created' });
          }
        }

        $scope.$on('TemplatesCreateSchedulesCreateController::Save', this.onTemplatesCreateSchedulesCreateControllerSave);
        $scope.$on('$destroy', $scope.$watch('templatesCreateSchedulesCreateTimes.isIndefinite', this.onIndefiniteUpdate));
        $scope.$on('$destroy', $scope.$watchCollection('templatesCreateSchedulesCreateTimes.repeatDays', this.onRepeatDaysUpdate));

        // Trigger $watch
        if (!this.model.honorHolidays && !this.model.honorOpenHours) {
          this.noExceptions = true;
        }

        // Next tick
        $timeout(function() {
          $scope.templatesCreateSchedulesCreateTimes.checkExceptions();
        }, 0);

        console.log('TemplatesCreateSchedulesCreateTimesController::init');

      },

      isStandard: function() {
        return (this.type === 'standard');
      },

      initWizard: function() {
        var self = $scope.templatesCreateSchedulesCreateTimes;
        this.wizard = new WizardFactory();
        this.wizard.init({
          name: 'times',
          validators: [{
            field: 'templates-create-schedules-create-times-capacity-min',
            greater: {
              message: 'A capacity of 0 or greater is required',
              test: function() {
                return {
                  greater: parseInt(self.model.capacity, 10),
                  less: -1
                };
              }
            }
          },
            {
              field: 'templates-create-schedules-create-times-duration-hr-min',
              greater: {
                message: 'Please enter valid duration hour',
                test: function() {
                  var greater = parseInt(self.model.duration.hour, 10);
                  if (self.isAdmissionType('generalAdmission')) {
                    greater = 1;
                  }
                  return {
                    greater: greater,
                    less: -1
                  };
                }
              }
            },
            {
              field: 'templates-create-schedules-create-times-duration-m-min',
              greater: {
                message: 'Please enter valid duration minutes',
                test: function() {
                  var greater = parseInt(self.model.duration.hour, 10);
                  if (self.isAdmissionType('generalAdmission')) {
                    greater = 0;
                  }
                  return {
                    greater: greater,
                    less: -1
                  };
                }
              }
            },
            {
              field: 'templates-create-schedules-create-times-duration-total',
              greater: {
                message: 'Events must be 1 minute or longer',
                test: function() {
                  return {
                    greater: parseInt(self.model.duration.hour, 10) + parseInt(self.model.duration.minutes, 10),
                    less: 0
                  };
                }
              }
            },
            {
              field: 'templates-create-schedules-create-times-ends',
              greater: {
                message: 'End date cannot be sooner than start date',
                test: function() {

                  var r = {
                    greater: 1,
                    less: 0
                  };

                  if (self.isIndefinite || (self.repeatFrequency.value === 'never')) {
                    r = {
                      greater: 1,
                      less: 0,
                      equalTo: true
                    };
                  } else {
                    r = {
                      greater: self.endTime.getTime(),
                      less: self.startTime.getTime(),
                      equalTo: true
                    };
                  }

                  return r;

                }
              }
            }]
        });
      },

      getCalendar: function() {
        ApiService.tenant.calendar.detail().then(this.success.getCalendar, this.error.getCalendar);
      },

      honorOpenHours: function() {
        return (this.model.honorOpenHours && this.calendar.all instanceof Array);
      },

      showOpenHours: function() {

        var self = this;

        this.showModal = $uibModal.open({
          templateUrl: 'views/application/views/templates/create/schedules/modals/openingHours.tpl.html',
          size: 'md',
          controller: 'TemplatesCreateSchedulesOpeningHoursModalController',
          resolve: {
            openHours: function () {
              return self.calendar.open;
            },
            closedHours: function () {
              return self.calendar.closed;
            },
            hourFormat: function () {
              return self.hourFormat;
            }
          }
        });
        // Invoked when modal completes with close(params)
        this.showModal.result.then(function () {
          // Do nothing
        }, function () {
          // Do nothing
        });

      },

      hasCalendarExceptions: function(ISODate) {
        var i, ii,
            r = false;

        if (this.model.honorHolidays) {
          if (this.calendar.exceptions instanceof Array) {
            for (i = 0, ii = this.calendar.exceptions.length; i < ii; i++) {
              if (this.calendar.exceptions[i].date === ISODate &&
                  this.calendar.exceptions[i].hours instanceof Array) {
                if (this.calendar.exceptions[i].hours[0] === 'closed') {
                  r = 'Closed all day';
                  break;
                } else if (this.calendar.exceptions[i].hours[0]) {
                  r = 'Open ' + CalendarService.rangeToTime(this.calendar.exceptions[i].hours[0]);
                }
              }
            }
          }
        }
        return r;
      },

      showExceptions: function() {

        var self = this;

        this.showModal = $uibModal.open({
          templateUrl: 'views/application/views/templates/create/schedules/modals/holidaysExceptions.tpl.html',
          size: 'md',
          controller: 'TemplatesCreateSchedulesHolidaysExceptionsModalController',
          resolve: {
            exceptions: function () {
              return self.calendar.exceptions;
            }
          }
        });
        // Invoked when modal completes with close(params)
        this.showModal.result.then(function () {
          // Do nothing
        }, function () {
          // Do nothing
        });

      },

      updateScheduleRangeValidators: function() {
        var i, ii;

        for (i=0,ii=this.scheduleRangeHours.length;i<ii;i++) {
          this.addScheduleRangeValidator(i);
        }
      },

      clearScheduleRangeValidators: function() {
        var i, ii;

        for (i=0,ii=this.scheduleRangeValidators.length;i<ii;i++) {
          this.wizard.removeValidator('times', 'templates-create-schedules-create-times-range-' + i);
          ValidateService.removeFieldTest({ field: 'templates-create-schedules-create-times-range-' + i });
          this.scheduleRangeValidators.splice(i, 1);
        }

        this.scheduleRangeValidators = [];
      },

      addScheduleRangeValidator: function(index) {

        var self = this,
            test = {
              field: 'templates-create-schedules-create-times-range-' + index,
              greater: {
                message: 'Hours cannot end before they begin',
                test: function() {
                  return {
                    greater: self.scheduleRangeHours[index].end.getTime(),
                    less: self.scheduleRangeHours[index].start.getTime()
                  };
                }
              }
            };

        this.scheduleRangeValidators.push(test);
        
        this.wizard.addValidator('times', this.scheduleRangeValidators[this.scheduleRangeValidators.length - 1]);

        ValidateService.addFieldTest(this.scheduleRangeValidators[this.scheduleRangeValidators.length - 1]);

      },

      isAdmissionType: function(type) {
        return TemplatesService.isAdmissionType(type);
      },

      addHour: function(index, fieldId) {
        this.model.hours.push(TemplatesService.createHour());
        this.scheduleHours.push(TemplatesService.hourToDate(this.model.hours[this.model.hours.length - 1]));
        // next tick
        $timeout(function() {
          $scope.templatesCreateSchedulesCreateTimes.setInputFocus($scope.templatesCreateSchedulesCreateTimes.scheduleHours.length-1, fieldId);
        }, 0);
      },

      removeHour: function(index, fieldId) {
        this.model.hours.splice(index, 1);
        this.scheduleHours.splice(index, 1);
        // next tick
        $timeout(function() {
          $scope.templatesCreateSchedulesCreateTimes.setInputFocus(index-1, fieldId);
        }, 0);
      },

      addRange: function(index, fieldId) {
        if (!this.model.ranges) {
          this.model.ranges = [];
        }
        this.model.ranges.push(TemplatesService.createRange());
        this.scheduleRangeHours.push({
          end: TemplatesService.hourToDate(this.model.ranges[this.model.ranges.length - 1].end),
          start: TemplatesService.hourToDate(this.model.ranges[this.model.ranges.length - 1].start)
        });

        this.addScheduleRangeValidator(this.scheduleRangeHours.length - 1);
        // next tick
        $timeout(function() {
          $scope.templatesCreateSchedulesCreateTimes.setInputFocus($scope.templatesCreateSchedulesCreateTimes.scheduleRangeHours.length-1, fieldId);
        }, 0);

      },

      removeRange: function(index, fieldId) {
        this.model.ranges.splice(index, 1);
        this.scheduleRangeHours.splice(index, 1);
        // next tick
        $timeout(function() {
          var self = $scope.templatesCreateSchedulesCreateTimes;
          // Need to reset the range validators because of old index references
          self.clearScheduleRangeValidators();
          self.updateScheduleRangeValidators();
          // Revalidate to clear old errors
          self.wizard.validate();

          $scope.templatesCreateSchedulesCreateTimes.setInputFocus(index-1, fieldId);

        }, 0);
      },

      setInputFocus: function(index, fieldId) {
        var el = $('#' + fieldId + '-' + (index || 0));
        if (el.length && el.find('input').length) {
          el.find('input').get(0).focus();
        }
      },

      rangeToTime: function(range) {
        return CalendarService.rangeToTime(range);
      },

      updateScheduleHours: function(index) {

        var d;

        if (this.model.hours[index]) {
          d = new Date(this.scheduleHours[index]);
          this.model.hours[index].hour = parseInt(d.getHours(), 10);
          this.model.hours[index].minutes = parseInt(d.getMinutes(), 10);
        }

      },

      updateScheduleRangeHours: function(index) {

        var ds,
            de;

        if (this.model.ranges[index]) {
          ds = new Date(this.scheduleRangeHours[index].start);
          de = new Date(this.scheduleRangeHours[index].end);
          this.model.ranges[index].start.hour = parseInt(ds.getHours(), 10);
          this.model.ranges[index].start.minutes = parseInt(ds.getMinutes(), 10);
          this.model.ranges[index].end.hour = parseInt(de.getHours(), 10);
          this.model.ranges[index].end.minutes = parseInt(de.getMinutes(), 10);
        }

      },

      getScheduleRepeatMonthType: function() {
        var i, ii,
          r = this.repeatMonthTypes[0];

        for (i=0,ii=this.repeatMonthTypes.length;i<ii;i++) {
          if (this.model.repeatMonthType === this.repeatMonthTypes[i].value) {
            r = this.repeatMonthTypes[i];
            break;
          }
        }

        return r;
      },

      setRepeating: function() {
        console.log('setRepeating', this.repeatFrequency.value, this.scheduleEndTime, this.model.effectiveEndTime, this.isIndefinite);
        this.isRepeating = (this.repeatFrequency.value && this.repeatFrequency.value !== 'never');
        this.model.repeatCycle = this.repeatFrequency.value;
        if (this.model.repeatCycle !== 'never' && !this.model.effectiveEndTime) {
          this.isIndefinite = true;
        }

        if (this.model.repeatCycle === 'day') {
          this.showWeekdays = false;
        }else if (this.model.repeatCycle === 'week') {
          this.showWeekdays = true;
        }else if (this.model.repeatCycle === 'month') {
          if (this.model.monthly instanceof Array && this.model.monthly.length > 0) {
            this.repeatMonthType = this.getRepeatMonthType(this.model.monthly[0]);
            this.showWeekdays = true;
          }else if (this.model.daysOfMonth instanceof Array && this.model.daysOfMonth.length > 0) {
            this.repeatMonthType = this.getRepeatMonthType('date');
            this.showWeekdays = false;
          }
        }

      },

      setRepeatDays: function(days) {
        var i, ii,
            day,
            isClosed;

        if (days instanceof Array) {
          for (day in this.repeatDays) {
            if (this.repeatDays.hasOwnProperty(day)) {
              if (this.honorOpenHours()) {
                isClosed = false;
                for (i=0,ii=this.calendar.closed.length;i<ii;i++) {
                  if (this.calendar.closed[i].day.match(new RegExp("^"+day))) {
                    isClosed = true;
                    break;
                  }
                }
                this.repeatDays[day] = (days.indexOf(day) !== -1 && !isClosed);
              }else {
                this.repeatDays[day] = (days.indexOf(day) !== -1);
              }
            }else{
              this.repeatDays[day] = false;
            }
          }
        }

      },

      getRepeatDays: function() {
        var day,
            days = [];

        for (day in this.repeatDays) {
          if (this.repeatDays.hasOwnProperty(day) && this.repeatDays[day] === true) {
            days.push(day);
          }
        }
        return days;
      },

      isRepeatCycle: function(cycle) {
        return (this.repeatFrequency.value === cycle);
      },

      isRepeatMonthType: function(type) {
        return (this.repeatMonthType.value === type);
      },

      isRepeatDaySelected: function(day) {
        return (this.repeatDays[day]);
      },

      addDayOfMonth: function(index, fieldId) {
        this.model.daysOfMonth.push(1);
        // next tick
        $timeout(function() {
          $scope.templatesCreateSchedulesCreateTimes.setInputFocus($scope.templatesCreateSchedulesCreateTimes.model.daysOfMonth.length-1, fieldId);
        }, 0);
      },

      removeDayOfMonth: function(index, fieldId) {
        this.model.daysOfMonth.splice(index, 1);
        // next tick
        $timeout(function() {
          $scope.templatesCreateSchedulesCreateTimes.setInputFocus(index-1, fieldId);
        }, 0);
      },

      checkRepeat: function() {
        var showWeekdays = false,
            sDate;

        if (this.isRepeatCycle('day')) {
          this.model.weekdays = ['Su', 'M', 'Tu', 'W', 'Th', 'F', 'Sa'];
          this.model.daysOfMonth = null;
          this.model.monthly = null;
        }else if (this.isRepeatCycle('week')) {
          this.model.monthly = null;
          this.model.daysOfMonth = null;
          showWeekdays = true;
        }else if ((this.isRepeatCycle('month') && (this.repeatMonthType.value !== 'date'))) {
          this.model.monthly = [ this.repeatMonthType.value ];
          this.model.daysOfMonth = null;
          showWeekdays = true;
        }else{
          if (!this.startTime.hasOwnProperty('getDate')) {
            sDate = new Date(this.startTime);
          }
          this.endTime = this.startTime;
          this.model.monthly = null;
          if (!(this.model.daysOfMonth instanceof Array && this.model.length > 0)) {
            this.model.daysOfMonth = [ 1 ];
          }
          this.model.weekdays = [];
        }

        this.showWeekdays = showWeekdays;

        this.setRepeating();
      },

      checkExceptions: function() {

        if (!this.model.honorHolidays && !this.model.honorOpenHours) {
          this.noExceptions = true;
        }else{
          this.noExceptions = false;
        }

        this.hasStartTimeException = this.hasCalendarExceptions(CalendarService.toISO8601(this.startTime).split('T')[0]);
        this.hasEndTimeException = this.hasCalendarExceptions(CalendarService.toISO8601(this.endTime).split('T')[0]);
        //this.setRepeatDays(this.model.weekdays);
        this.checkClosedDays(this.repeatDays);
        this.checkOpeningHours();
      },

      checkClosedDays: function(days) {
        var i, ii,
            day;

        if (this.calendar && this.calendar.closed instanceof Array) {
          if (days) {
            for (i = 0, ii = this.calendar.closed.length; i < ii; i++) {
              this.calendar.closed[i].warning = false;

              for (day in days) {
                if (days[day] && CalendarService.weekdays[day].name === this.calendar.closed[i].day) {
                  this.calendar.closed[i].warning = true;
                  break;
                }
              }
            }
          }
        }
      },

      checkOpeningHours: function() {
        var i, ii,
            j, jj,
            k, kk,
            openEnd,
            hoursEnd,
            rangeStart,
            rangeStartHour,
            rangeStartMinute,
            rangeStartMeridian,
            rangeHoursStartHour;

        if (this.calendar && this.calendar.open instanceof Array) {
          outer: for (i = 0, ii = this.calendar.open.length; i < ii; i++) {
            for (j = 0, jj = this.scheduleRangeHours.length; j < jj; j++) {
              // Get range start time
              this.scheduleRangeHours[j].warning = false;

              if (this.isRepeatDaySelected(CalendarService.getWeekdayShortName(this.calendar.open[i].day))) {

                if (this.model.honorOpenHours) {

                  rangeStart = CalendarService.toISO8601(this.scheduleRangeHours[j].start).split('T')[1];

                  rangeStartHour = CalendarService.toHour(+rangeStart.split(':')[0]);
                  rangeStartMinute = CalendarService.toMinutes(+rangeStart.split(':')[1]);
                  rangeStartMeridian = CalendarService.getMeridian(+rangeStart.split(':')[0]);

                  rangeHoursStartHour = CalendarService.timeToDate(rangeStartHour + ':' + rangeStartMinute + ' ' + rangeStartMeridian);
                  for (k = 0, kk = this.calendar.open[i].hours.length; k < kk; k++) {
                    // Get open hours end time
                    hoursEnd = this.calendar.open[i].hours[k].split(' to ')[1];
                    openEnd = CalendarService.timeToDate(hoursEnd);
                    if (rangeHoursStartHour.getTime() >= openEnd.getTime()) {
                      this.scheduleRangeHours[j].warning = this.calendar.open[i].day + ' hours: ' + this.calendar.open[i].hours[k];
                      break outer;
                    }
                  }
                }
              }
            }
          }
        }
      },

      editExceptions: function() {
        this.exceptionsCache.honorOpenHours = this.model.honorOpenHours;
        this.exceptionsCache.honorHolidays = this.model.honorHolidays;
        this.checkExceptions();
        this.allowEditExceptions = true;
      },

      saveExceptions: function() {
        this.exceptionsCache.honorOpenHours = this.model.honorOpenHours;
        this.exceptionsCache.honorHolidays = this.model.honorHolidays;
        this.checkExceptions();
        this.allowEditExceptions = false;
      },

      cancelExceptions: function() {
        this.model.honorOpenHours = this.exceptionsCache.honorOpenHours;
        this.model.honorHolidays = this.exceptionsCache.honorHolidays;
        this.checkExceptions();
        this.allowEditExceptions = false;
      },

      processCalendar: function(calendar) {
        var i, ii,
            j, jj,
            k, kk,
            all = {},
            open = {},
            closed = {},
            weekdays = CalendarService.getWeekdayArray();

        if (calendar.standard instanceof Array &&
            calendar.standard.length) {

          // Add delta of closed and open hours
          calendar.all = [];
          calendar.open = [];
          calendar.closed = [];

          for (j=0,jj=weekdays.length;j<jj;j++) {
            for (i=0,ii=calendar.standard.length;i<ii;i++) {
              all = {};
              open = {};
              closed = {};

              // We only save one day per object so no need to iterate for now
              if (calendar.standard[i].weekdays instanceof Array &&
                calendar.standard[i].weekdays.length &&
                weekdays[j] === calendar.standard[i].weekdays[0]) {

                all.day = calendar.standard[i].weekdays[0];
                open.day = calendar.standard[i].weekdays[0];

                if (calendar.standard[i].hours instanceof Array &&
                  calendar.standard[i].hours.length) {
                  all.hours = [];
                  open.hours = [];
                  for (k=0,kk=calendar.standard[i].hours.length;k<kk;k++) {
                    all.hours.push(CalendarService.rangeToTime(calendar.standard[i].hours[k]), UserPreferencesService.hasPreferences('standardTime'));
                    open.hours.push(CalendarService.rangeToTime(calendar.standard[i].hours[k]));
                  }
                }
                break;
              }else{
                all.day = weekdays[j];
                all.hours = [ 'Closed' ];
                closed.day = weekdays[j];
                closed.hours = [ 'Closed' ];
              }
            }

            calendar.all.push(all);

            if (open.hours instanceof Array) {
              calendar.open.push(open);
            }

            if (closed.hours instanceof Array) {
              calendar.closed.push(closed);
            }

          }

        }

        return calendar;
      },

      success: {
        init: function(response) {},
        getCalendar: function(response) {
          var self = $scope.templatesCreateSchedulesCreateTimes;
          self.calendar = self.processCalendar(response.data.payload);
          if (self.calendar.exceptions instanceof Array || self.calendar.standard instanceof Array) {
            $scope.$on('$destroy', $scope.$watch('templatesCreateSchedulesCreateTimes.startTime', self.onStartTimeUpdate));
            $scope.$on('$destroy', $scope.$watch('templatesCreateSchedulesCreateTimes.endTime', self.onEndTimeUpdate));
          }
        }
      },

      error: {
        init: function(response) {},
        getCalendar: function(response) {}
      },

      onTemplatesCreateSchedulesCreateControllerSave: function() {
        var self = $scope.templatesCreateSchedulesCreateTimes;

        self.model.effectiveStartTime = CalendarService.toISO8601(self.startTime);
        self.model.repeatCycle = self.repeatFrequency.value;

        if (self.isIndefinite) {
          self.model.effectiveEndTime = null;
        }else{
          if (self.model.repeatCycle === 'never' && self.startTime) {
            self.endTime = new Date(self.startTime.getFullYear(), self.startTime.getMonth(), self.startTime.getDate(), 23, 59, 59);
          }else{
            self.endTime = new Date(self.endTime.getFullYear(), self.endTime.getMonth(), self.endTime.getDate(), 23, 59, 59);
          }
          self.model.effectiveEndTime = CalendarService.toISO8601(self.endTime);
        }
        // Only assign weekdays when visible
        if (self.showWeekdays) {
          self.model.weekdays = self.getRepeatDays();
        }

        TemplatesService.setSchedule(self.model);
        TemplatesService.verifySchedules();

        self.wizard.validate();
      },

      onIndefiniteUpdate: function(n, o) {
        var self = $scope.templatesCreateSchedulesCreateTimes;
        if (n) {
          self.model.effectiveEndTime = null;
        }else{
          self.model.effectiveEndTime = CalendarService.toISO8601(new Date(self.endTime.getFullYear(), self.endTime.getMonth(), self.endTime.getDate(), 23, 59, 59));
        }
      },

      onRepeatDaysUpdate: function(n, o) {
        var self = $scope.templatesCreateSchedulesCreateTimes;
        self.checkClosedDays(n);
        self.checkOpeningHours();
      },

      onStartTimeUpdate: function(n, o) {
        var self = $scope.templatesCreateSchedulesCreateTimes,
            date = CalendarService.toISO8601(n);
        self.hasStartTimeException = date && self.hasCalendarExceptions(date.split('T')[0]);
      },

      onEndTimeUpdate: function(n, o) {
        var self = $scope.templatesCreateSchedulesCreateTimes,
            date = CalendarService.toISO8601(n);
        self.hasEndTimeException = date && self.hasCalendarExceptions(date.split('T')[0]);
      }

    };

    $scope.templatesCreateSchedulesCreateTimes.init();

}]);